import type { PresenceContact } from '../../lib/useMessagerie';

import { etatPresence, LIBELLE_PRESENCE } from './presence';

/** Point de présence façon Discord, à poser en overlay d'un avatar. */
export function BadgePresence({
  presence,
  className = 'h-3 w-3',
}: {
  presence: PresenceContact;
  className?: string;
}): JSX.Element {
  const etat = etatPresence(presence);

  if (etat === 'ne_pas_deranger') {
    return (
      <svg className={`shrink-0 ${className}`} viewBox="0 0 16 16" role="img" aria-label={LIBELLE_PRESENCE[etat]}>
        <circle cx="8" cy="8" r="7" fill="#ef4444" stroke="white" strokeWidth="2" />
        <rect x="4.5" y="7" width="7" height="2" rx="1" fill="white" />
      </svg>
    );
  }

  return (
    <span
      role="img"
      aria-label={LIBELLE_PRESENCE[etat]}
      className={`inline-block shrink-0 rounded-full border-2 border-white ${className} ${
        etat === 'actif' ? 'bg-green-500' : 'bg-gray-300'
      }`}
    />
  );
}
